
import * as PnpSettingsActionsDocumentType from '../../pnp-settings.actions';

export const pnpDocumentTypesDetails = {
    /* @ngInject */
    controller: function ($ngRedux,
        $scope,
        $state,
        $stateParams,
        $filter,
        $timeout,
        $location,
        $mdDialog,
        FileUploader,
        Notifier,
        FileActions) {


        const unsubscribe = $ngRedux.connect(({ pnp }) => ({
            pnpSettingsDocumentType: pnp.pnpSettingsDocumentType
        }), {
            ...FileActions,
            ...PnpSettingsActionsDocumentType
        })(this);

        /**
         * @function $onInit
         * @returns {Promise<void>}
         */
        this.$onInit = async () => {
            this.identifier = 'pnpSettingsDocumentType';
        }


        this.onButtonCancel = () => {

        }

        this.onButtonBack = () => {

        }

        this.saveDetails = () => {
            $scope.$broadcast('show-errors-check-validity', '$ctrl.pnpSettingsDocumentTypeForm');
            if (this.pnpSettingsDocumentTypeForm.$valid) {
                this.saveDocumentType(this.pnpSettingsDocumentType).then(() => {
                    Notifier.success('New document type has been successfully saved');
                    isNull(this.pnpSettingsDocumentType.id) && resetForm();
                }).catch(() => {
                    Notifier.error('System Error!');
                });
            } else {
                Notifier.error('Please fill in the form fields');
            }
        }

        const resetForm = () => {
            $rootScope.$broadcast('SELECT_CASCADE_RESET', '$ctrl.pnpSettingsDocumentTypeForm');
            this.pnpSettingsDocumentType.$setPristine();
            this.pnpSettingsDocumentType.$setUntouched();
        };

        /**
         * @function $onDestroy
         */

        this.$onDestroy = () => {
            unsubscribe();
        }
    },

    template: require('./pnp-document-type-details.html')
}
